import { css } from 'lit';
import JhaStyleElement from '../../style-element/JhaStyleElement.js';
import { jhaStyles } from '../../styles/jha-styles.js';

/**
 * A JHA Design slider pane component. Used as a single pane inside a jha-slider-content component.
 * @element jha-slider-pane
 * @attr {boolean} one - Used on the initial pane to be displayed.
 * @attr {boolean} focus - Used to set the current pane to be visible.
 * @attr {boolean} left - Used via javascript (in jha-slider-content) to manage animating panes.
 * @attr {boolean} right - Used via javascript (in jha-slider-content) to manage animating panes.
 *
 */
export default class JhaSliderPane extends JhaStyleElement {
  static get styles() {
    return [
      jhaStyles,
      css`
        @keyframes fadeInRight {
          0% {
            opacity: 0;
            visibility: hidden;
            transform: translateX(100%);
          }
          100% {
            opacity: 1;
            visibility: visible;
            transform: translateX(0);
          }
        }
        @keyframes fadeOutLeft {
          0% {
            opacity: 1;
            visibility: visible;
            transform: translateX(0);
          }
          100% {
            opacity: 0;
            visibility: hidden;
            transform: translateX(-100%);
          }
        }
        @keyframes fadeInLeft {
          0% {
            opacity: 0;
            visibility: hidden;
            transform: translateX(-100%);
          }
          100% {
            opacity: 1;
            visibility: visible;
            transform: translateX(0);
          }
        }
        @keyframes fadeOutRight {
          0% {
            opacity: 1;
            visibility: visible;
            transform: translateX(0);
          }
          100% {
            opacity: 0;
            visibility: hidden;
            transform: translateX(100%);
          }
        }
        :host {
          display: block;
          width: 100%;
          position: absolute;
        }
        :host([one][focus]) {
          animation: none;
        }
        :host([left]) {
          animation: fadeOutLeft ease 0.4s;
        }
        :host([right]) {
          animation: fadeOutRight ease 0.4s;
        }
        :host([focus][left]) {
          animation: fadeInLeft ease 0.4s;
        }
        :host([focus]) {
          animation: fadeInRight ease 0.4s;
          position: relative;
        }
        :host(:not([focus])) {
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
        }
      `,
    ];
  }
}
